/*跨域地址*/
const dev = process.env.dev
const rescApi = process.env.rescApi

export default {
  /**提交问卷答案 */
  submitAnswers: {
    url: dev + '/sv/order/question',
    method: 'post'
  },
  /** 获取用户信息*/
  getQuestionnaireUserInfo: {
    url: dev + '/sv/order/cust',
    method: 'get'
  },
  /**获取问卷答案 */
  getQuestionnaireAnswer: {
    url: dev + '/sv/order/question',
    method: 'get'
  },
  /**创建数据回流 */
  creatDataFlow: {
    url: rescApi + '/data/flow',
    method: 'post'
  },
  /**生成访问时长 */
  produceVisitedHours: {
    url: rescApi + '/data/flow/brow/time',
    method: 'post',
    config: {
      closeLoading: true
    }
  },
};



// WEBPACK FOOTER //
// ./src/api/questionnaire.js